import { render, staticRenderFns } from "./SegmentedTabs.vue?vue&type=template&id=fd2aeda4&scoped=true"
import script from "./SegmentedTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedTabs.vue?vue&type=style&index=0&id=fd2aeda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2aeda4",
  null
  
)

export default component.exports